import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { DistrictService } from '../../services/district.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';

@Component({
  selector: 'app-student-scripts-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent],
  templateUrl: './student-scripts-list-page.component.html',
  styleUrl: './student-scripts-list-page.component.css'
})
export class StudentScriptsListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Script';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  isSubmitting = false;
  items: any[] = [
    { university: 'Mumbai University', academic_year: '2024-25', subject: 'Mathematics', exam: 'Mid Term', barcode: 'BC001234' },
    { university: 'Mumbai University', academic_year: '2024-25', subject: 'Physics', exam: 'Mid Term', barcode: 'BC001235' },
    { university: 'Pune University', academic_year: '2024-25', subject: 'Chemistry', exam: 'End Term', barcode: 'BC001236' },
    { university: 'Mumbai University', academic_year: '2023-24', subject: 'Mathematics', exam: 'End Term', barcode: 'BC001237' },
    { university: 'Pune University', academic_year: '2024-25', subject: 'Physics', exam: 'Supplementary', barcode: 'BC001238' }
  ];

  // Filter variables
  filters: any = {
    university_id: '',
    academic_year_id: '',
    subject_id: '',
    exam_id: ''
  };

  // Static filter dropdown lists
  university_list = [
    { title: 'University 1', value: 1 },
    { title: 'University 2', value: 2 },
    { title: 'University 3', value: 3 }
  ];

  academic_year_list = [
    { title: '2023-24', value: 1 },
    { title: '2024-25', value: 2 },
    { title: '2025-26', value: 3 }
  ];

  subject_list = [
    { title: 'Mathematics', value: 1 },
    { title: 'Physics', value: 2 },
    { title: 'Chemistry', value: 3 }
  ];

  exam_list = [
    { title: 'Mid Term', value: 1 },
    { title: 'End Term', value: 2 },
    { title: 'Supplementary', value: 3 }
  ];

  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'date', headerName: 'Date', filter: true, flex: 1 },
    { field: 'university', headerName: 'School', filter: true, flex: 1 },
    { field: 'exam', headerName: 'Exam', filter: true, flex: 1 },
    { field: 'subject', headerName: 'Subject', filter: true, flex: 1 },
    { field: 'total_pages', headerName: 'Total Pages', filter: true, flex: 1 },
    { field: 'barcode', headerName: 'Barcode', filter: true, flex: 1 },
    { field: 'L1_code', headerName: 'L1 Code', filter: true, flex: 1 },
    { field: 'L2_code', headerName: 'L2 Code', filter: true, flex: 1 },
    { field: 'academic_year', headerName: 'Academic Year', filter: true, flex: 1 },
    { field: 'exam', headerName: 'Exam', filter: true, flex: 1 },
    { field: 'barcode', headerName: 'Bar Code', filter: true, flex: 1 }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'text', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'text', return_as: 'name', sample_value: 'Mumbai City' },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai' },
  ];

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DistrictService, public ar: ActivatedRoute, public dds: DropdownService,) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      division_id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      code: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(10), Validators.pattern('^[a-zA-Z0-9]+$')]],
    });
  }
  async ngOnInit() {
    await this.dds?.get_dropdown_list(['country', 'state', 'division', 'district']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.ds.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async delete() {
    let res = await this.ds.delete(this.selected_ids.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.ds.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ds.get(item.id);
      this.selected_ids = { ...response.data };
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ds.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ds.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      await this.gs.bulk_form_submission(data, this.ds, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }

}
